import { useAppSelector } from '@/store/hooks';
import React from 'react';
import { useSelector } from 'react-redux';

const { useEffect } = React;

export default function Heap() {
  const { userProfile } = useAppSelector(state => state.me);
  const { whitelabel } = useAppSelector(state => state.currentWhitelabel);
  const isImpersonationMode = useSelector(({ auth }) => auth.isImpersonationMode);

  useEffect(() => {
    const shouldTrack = window.heap && !isImpersonationMode && userProfile?.email && whitelabel?.whitelabelName;
    if (shouldTrack) {
      const properties = {
        WhitelabelName: whitelabel.whitelabelName,
        Name: `${userProfile.firstName || ''} ${userProfile.lastName || ''}`,
      };
      window.heap.identify(userProfile.email);
      window.heap.addUserProperties(properties);
    }
  }, [userProfile?.email, whitelabel?.whitelabelName, isImpersonationMode]);

  return null;
}
